import { BlocklistedCharacterSetForName } from "../common/commonConstants";

export function handleInputCheck(input: string) {
  const charIndex = Object.values(BlocklistedCharacterSetForName).findIndex((char) => input.includes(char));
  if (charIndex >= 0) return BlocklistedCharacterSetForName[charIndex] + " is an invalid character.";
  else return "";
}
